import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ProfileService } from './profile.service';
import { ProfileInfo } from './profile-info.model';

@Component({
    selector: 'app-page-ribbon',
    standalone: true,
    imports: [CommonModule],
    template: `
        @if (ribbonEnv) {
            <div class="ribbon">
                <a href="">{{ ribbonEnv }}</a>
            </div>
        }
    `,
    styleUrls: ['page-ribbon.css']})
export class PageRibbonComponent implements OnInit {
    profileInfo: ProfileInfo;
    ribbonEnv: string;

    constructor(private profileService: ProfileService) {}

    ngOnInit() {
        this.profileService.getProfileInfo().then(profileInfo => {
            this.profileInfo = profileInfo;
            this.ribbonEnv = profileInfo.ribbonEnv;
        });
    }
}
